import { api } from "./api.service";

export interface GoogleCalendarEvent {
  id: string | null;
  summary: string | null;
  description: string | null;
  start: string | null; // ISO
  end: string | null;   // ISO
}

export interface GoogleAuthUrlResponse {
  url: string;
}

export interface GoogleIntegrationStatusResponse {
  connected: boolean;
  authUrl?: string;
}

export async function getGoogleAuthUrl(): Promise<string> {
  const { data } = await api.get<GoogleAuthUrlResponse>("/google/auth-url");
  return data?.url;
}

export async function getGoogleIntegrationStatus(): Promise<GoogleIntegrationStatusResponse> {
  const { data } = await api.get<GoogleIntegrationStatusResponse>("/google/status");
  return data;
}

export async function listGoogleEventsForDay(dateISO: string): Promise<GoogleCalendarEvent[]> {
  // dateISO deve ser uma string de data completa ou início do dia. Aqui normalizamos para o dia inteiro.
  const day = new Date(dateISO);
  if (Number.isNaN(day.getTime())) {
    return [];
  }

  const start = new Date(day);
  start.setHours(0, 0, 0, 0);

  const end = new Date(day);
  end.setHours(23, 59, 59, 999);

  const timeMin = start.toISOString();
  const timeMax = end.toISOString();

  const { data } = await api.get<{ events: GoogleCalendarEvent[] }>("/google/events", {
    params: { timeMin, timeMax },
  });

  const events = Array.isArray((data as any)?.events) ? (data as any).events : [];
  return events.map((e:any) => ({
    id: e.id ?? null,
    summary: e.summary ?? null,
    description: e.description ?? null,
    start: e.start ?? null,
    end: e.end ?? null,
  }));
}
